import { SoundType } from '@monorepo/shared/src/providers/ActivityAudioProvider/types';

export const formatSounds = (sounds) => {
  return sounds.map((sound) => {
    return formatSound(sound.description, sound.src, sound.vtt, sound.description);
  });
};

export const formatSound = (
  name: string,
  src: string,
  vtt: string,
  category = 'instructions'
): SoundType => {
  return {
    name,
    category,
    src: { src, vtt },
  };
};
